<template>
  <div class="content">
    <p class="p1">积分规则(仅限临猗在线注册用户)</p>
    <p class="p2">1、获取积分：</p>
    <p class="p3">
      （1）进入版块：点击进入新闻版块，可获得2个积分。每日上限为2个积分。<br />
      （2）阅读新闻、视频点播：<br />
      打开一篇新闻，包括普通新闻、专题、图文直播等，可获得1个积分。每日上限各为5个积分。<br />
      （3）评论新闻、视频点播：<br />
      打开一篇新闻，通过评论框编写评论，点击发送成功，可获得1个积分。每日上限各为5个积分。 <br />
      （4）分享新闻、视频点播：<br />
      打开一篇新闻，点击右下方的分享按钮，选择分享的渠道，点击分享，可获得1个积分。每日上限各为5个积分。<br />
      （5）点赞新闻页面：打开一篇新闻，点击资讯下方的点赞按钮，可获得1个积分。每日上限为5个积分。<br />
      （6）阅读拍客、同城、监督台：<br />
      打开一篇新闻，包括普通新闻、专题、图文直播等，可获得1个积分。每日上限各为3个积分。<br />
      （7）评论拍客、同城、监督台：<br />
      打开一篇新闻，通过评论框编写评论，点击发送成功，可获得1个积分。每日上限各为3个积分。 <br />
      （8）分享拍客、同城、监督台页面： <br />
      打开一篇新闻，点击右下方的分享按钮，选择分享的渠道，点击分享，可获得1个积分。每日上限各为3个积分。<br />
      （9）点赞拍客、同城、监督台页面：打开一篇新闻，点击资讯下方的点赞按钮，可获得1个积分。每日上限各为3个积分。<br />
      （10）在拍客、同城、监督台发布帖子：可获得1个积分。每日上限各为3个积分。<br />
      （11）邀请好友：邀请好友可获1积分。好友使用邀请码注册可获得100积分。无上限。<br />
    </p>
    <p class="p2">2、违规说明：</p>
    <p class="p3">
      为了给资讯用户提供更好的言论环境，以下是针对违规和作弊行为的相关规定： <br />
      （1）为给用户提供更好的言论环境，严禁各类违规和作弊行为。<br />
      （2）禁止发布任何形式的广告内容，违规视情节轻重给予禁言或封号处理。<br />
      （3）严禁利用任何违法违规手段刷分，一经发现直接封号处理，所有积分自动清零。<br />
    </p>
    <p class="p2 p4"><strong>积分规则最终解释权归临猗在线所有</strong></p>
    <br />
  </div>
</template>
<script>
const PalauAPI = window.PalauAPI
export default {
  mounted() {
    if (typeof SZJSBridge !== 'undefined') {
      PalauAPI.view.showHeader()
      PalauAPI.view.toggleShareBtn()
    }
  }
}
</script>
<style lang="stylus">
.content
  width 100%
  height: 100%;
  overflow-x hidden
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch
  position relative
  padding 0 30px
.p1
  font-weight bold
  font-size 40px
  margin 40px 0 20px 0
.p2
  font-weight bold
  font-size 34px
  margin 10px 0 10px 0
.p3
  line-height 44px
  font-size 30px
  padding 0 30px
.p4
  padding 0 30px
</style>
